// TODO: generate this file, based on info in wp-data/pages.json, and pages/index.js
import App from '../containers/App'

import HomePage from '../pages/HomePage'
import AboutPage from '../pages/AboutPage'
import InstallPage from '../pages/InstallPage'
// NOT ACTIVE: we have a redirect on S3 to Medium, until further.
// import BlogIndexPage from '../pages/BlogIndexPage'
// import BlogPostPage from '../pages/BlogPostPage'
import CaseStudyPage from '../pages/CaseStudyPage'
import EnterprisePage from '../pages/EnterprisePage'
import AirstreamPage from '../pages/AirstreamPage'
import AirstreamMediakitPage from '../pages/AirstreamMediakitPage'
import PressPage from '../pages/PressPage'
import TechnologyPage from '../pages/TechnologyPage'
import ContactPage from '../pages/ContactPage'
import SnipsHomeCampaignPage from '../pages/SnipsHomeCampaignPage'
import SeedsIndexPage from '../pages/seeds/IndexPage'
import EmotionalSnapshotPage from '../pages/seeds/EmotionalSnapshotPage'
import PrivacyPolicyDataGenPage from '../pages/PrivacyPolicyDataGenPage'

// react router 2.x function
function redirectToHome (nextState, replace) {
  replace('/', null)
  return false
}

function redirectToContact (nextState, replace) {
  replace('/contact', null)
  return false
}

// * wpPageId is id from WordPress,
// if present page will be rendered with data prop, being the data
// fetched from WP api
// * darkHeaderBackground is used to set the initial state for the header (dark or light),
// needed for the server render
// * noRender - don't render this automatically as a (single) html page
// used for blog post pages, which have separate render to html function,
// and for redirect routes

// NOTE: if you update the childRoutes here, need to also update the index.test.js file
const routes = {
  component: App,
  childRoutes: [
    {
      path: '/',
      component: HomePage,
      wpPageId: 946,
      darkHeaderBackground: true,
      preloadWpDataClientSide: true
    },
    { path: '/install', component: InstallPage },
    {
      path: '/technology',
      component: TechnologyPage,
      wpPageId: 1139,
      darkHeaderBackground: true,
      preloadWpDataClientSide: true
    },
    {
      path: '/about',
      component: AboutPage,
      wpPageId: 9,
      darkHeaderBackground: true
    },
    {
      path: '/enterprise',
      component: EnterprisePage,
      wpPageId: 1792,
      darkHeaderBackground: true
    },
    {
      path: '/airstream',
      component: AirstreamPage,
      wpPageId: 2499,
      darkHeaderBackground: true
    },
    {
      path: '/airstream/mediakit',
      component: AirstreamMediakitPage,
      wpPageId: 2577,
      darkHeaderBackground: true
    },
    {
      path: '/privacy-policy/data-gen',
      component: PrivacyPolicyDataGenPage,
      wpPageId: 2905,
      darkHeaderBackground: true
    },
    {
      path: '/press',
      component: PressPage,
      wpPageId: 10,
      darkHeaderBackground: true
    },
    {
      path: '/contact',
      component: ContactPage,
      wpPageId: 829,
      darkHeaderBackground: true
    },
    // { path: '/blog/:slug', component: BlogPostPage, noRender: true },
    // {
    //   path: '/blog',
    //   component: BlogIndexPage,
    //   wpPageId: 938,
    //   darkHeaderBackground: true
    // },
    {
      path: '/case-studies/:slug',
      component: CaseStudyPage,
      noRender: true,
      darkHeaderBackground: true
    },
    // MARKETING (TMP)
    { path: '/home/campaign', component: SnipsHomeCampaignPage },
    // SEEDS
    {
      path: '/seeds/emotional-snapshot',
      component: EmotionalSnapshotPage,
      wpPageId: 1043
    },
    {
      path: '/seeds',
      component: SeedsIndexPage,
      wpPageId: 1278,
      darkHeaderBackground: true
    },
    // redirects
    { path: '/support', onEnter: redirectToContact, noRender: true },
    { path: '/privacy-policy', onEnter: redirectToHome, noRender: true },
    { path: '*', onEnter: redirectToHome, noRender: true }
  ]
}

export default routes

export function getWpPageIds () {
  return routes.childRoutes
    .map(p => p.wpPageId)
    .filter(wpPageId => typeof wpPageId === 'number')
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/routes/index.js